import { render } from "./BoardPress.vue?vue&type=template&id=20208a7e"
import script from "./BoardPress.vue?vue&type=script&lang=js"
export * from "./BoardPress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__